export default "__VITE_ASSET__Dfwaba3v__"